<template>
  <div class="common">
    <div class="common-top">
      <!-- <img src="../assets/avatar.png" alt="" class="common-top-avatar"> -->
      <!-- <p class="common-top-avatar">杭州珍炫科技有限公司</p> -->
      <img src="../assets/zhenxuan.png" alt="" class="common-top-avatar" />
      <div class="common-top-header">
        <div class="common-top-header-left" v-if="logon && logon.userType != 3">
          <!-- <el-tabs v-model="activeName" @tab-click="handleLink($event,item.path)"  v-for="(item,index) in headerList" :key="index" >
            <el-tab-pane :label="item.label" :name="item.label"></el-tab-pane>
          </el-tabs> -->
          <span
            v-for="(item, index) in headerList"
            :key="index"
            @click="handleLink(item.path, index)"
            :style="activeName == index ? 'color:#4476ef' : ''"
            >{{ item.label }}</span
          >
        </div>
        <div
          class="common-top-header-left adminStyle"
          v-else-if="logon && logon.userType == 3"
        >
          <!-- <el-tabs v-model="activeName" @tab-click="handleLink($event,item.path)"  v-for="(item,index) in headerList" :key="index" >
            <el-tab-pane :label="item.label" :name="item.label"></el-tab-pane>
          </el-tabs> -->
          <span
            v-for="(item, index) in adminList"
            :key="index"
            @click="handleLink(item.path, index)"
            :style="activeName == index ? 'color:#4476ef' : ''"
            >{{ item.label }}</span
          >
        </div>
        <!-- 未登录状态显示默认导航 -->
        <div class="common-top-header-left" v-else>
          <span
            v-for="(item, index) in headerList"
            :key="index"
            @click="handleLink(item.path, index)"
            :style="activeName == index ? 'color:#4476ef' : ''"
            >{{ item.label }}</span
          >
        </div>
        <div class="common-top-header-right">
          <div
            class="common-top-header-right-bottom bottom2"
            @click="handlePublish"
            v-if="logon && logon.userType != 3"
          >
            发布项目
          </div>
          <div
            class="common-top-header-right-bottom bottom1"
            @click="handleLogin"
            v-if="!isLoad"
          >
            登录
          </div>
          <div
            class="common-top-header-right-user"
            v-else
            @mouseenter="showElement"
            @mouseleave="hideElement"
          >
            <img src="../assets/default.png" alt="" class="avatar" />
            <div class="count">
              <p>账号：</p>
              {{ logon.userName }}
            </div>
            <img
              src="../assets/down_arrow.png"
              alt=""
              style="width: 16px; height: 16px"
            />
            <div class="common-top-header-right-user-toptip" v-if="show">
              <p @click="handleLink('/mine')" v-if="logon.userType != 3">
                我发布的
              </p>
              <span @click="handleLogout">退出登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <KeepAlive>
      <router-view />
    </KeepAlive>
    <div style="background: #4787f0; padding-bottom: 20px">
      <div class="common-footer">
        <div class="common-footer-left">
          <h1>杭州珍炫科技有限公司</h1>
          <!-- <h3 style="cursor: pointer;" @click="toBeian">备案号：浙ICP备2024070540号</h3> -->
        </div>
        <div class="common-footer-right">
          <h2>联系我们</h2>
          <h4>电话：13216197505</h4>
          <p>
            地址：浙江省杭州市富阳区银湖街道富闲路9号银湖创新中心6号12层1232室
          </p>
        </div>
      </div>
      <div class="xy">
        <a href="javascript:;" @click.stop="openAgreement"
          >《平台服务协议与管理制度》</a
        >
      </div>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        "
      >
        <img src="../assets/jhui.png" alt="" />
        <h4 style="cursor: pointer" @click="toBeian">
          备案号：浙ICP备2025214100号-1
        </h4>
        &nbsp;Copyright2016-2026 杭州珍炫科技有限公司 &nbsp;All Rights Reserved
        杭州珍炫科技有限公司 版权所有
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from "../utils/login";
import { mapState } from "vuex";
export default {
  name: "topHeader",
  components: {},
  data() {
    return {
      headerList: [
        {
          label: "首页",
          path: "/",
        },
        {
          label: "广告策划",
          path: "/advertisement",
        },
        {
          label: "企业咨询",
          path: "/consult",
        },
        {
          label: "数字内容制作",
          path: "/digit",
        },
        {
          label: "系统平台搭建",
          path: "/platform",
        },
        {
          label: "关于我们",
          path: "/about",
        },
      ],
      adminList: [
        {
          label: "广告策划审核",
          path: "/advertisementRecords",
        },
        {
          label: "企业咨询审核",
          path: "/consultRecords",
        },
        {
          label: "数字内容制作审核",
          path: "/digitRecords",
        },
        {
          label: "系统平台搭建审核",
          path: "/platformRecords",
        },
        {
          label: "用户审核",
          path: "/userRecords",
        },
      ],
      isLoad: false,
      logon: undefined,
      show: false,
      // activeName:"首页",
      active: 0,
    };
  },
  computed: {
    ...mapState({
      activeName: (state) => state.activeName,
    }),
  },
  methods: {
    openAgreement() {
      // 弹窗宽高
      window.open("/agreement.html", "_blank");
    },
    handleLogin() {
      this.$router.push("/login");
    },
    handlePublish() {
      if (!this.isLoad) {
        this.$message.warning("请先登录帐号!");
        setTimeout(() => {
          this.$router.push("/login");
        }, 1000);
        return;
      }
      this.$store.commit("SET_ACTIVE", -1);
      this.$router.push("/publish");
    },
    handleLink(path, index) {
      try {
        this.$store.commit("SET_ACTIVE", index);
        // 保存active状态到localStorage，确保刷新后保持不变
        localStorage.setItem("activeName", index.toString());
        this.$router.push(path);
      } catch (error) {
        console.error("处理链接点击失败:", error);
        // 即使出错也尝试跳转
        this.$router.push(path);
      }
    },
    showElement() {
      this.show = true;
    },
    hideElement() {
      this.show = false;
    },
    handleLogout() {
      logout().then((res) => {
        localStorage.removeItem("loginstate");
        this.$router.push("/login");
      });
    },
    toBeian() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
  },
  created() {
    try {
      // 安全获取登录状态
      const loginStateStr = localStorage.getItem("loginstate");
      if (loginStateStr) {
        this.logon = JSON.parse(loginStateStr);
        if (this.logon) {
          this.isLoad = true;
        }
      }
    } catch (error) {
      console.error("获取登录状态失败:", error);
      this.logon = null;
      this.isLoad = false;
    }

    // 从localStorage恢复active状态，确保刷新后保持不变
    try {
      const savedActive = localStorage.getItem("activeName");
      if (savedActive !== null) {
        this.$store.commit("SET_ACTIVE", parseInt(savedActive));
      }
    } catch (error) {
      console.error("恢复active状态失败:", error);
    }
  },

  // 使用mounted钩子进行路由跳转，确保组件已经渲染完成
  mounted() {
    if (this.logon && this.logon.userType === 3) {
      // 检查是否是首次登录或刷新，避免重复跳转
      const currentPath = this.$route.path;
      if (currentPath === "/" || currentPath === "/login") {
        // 使用nextTick确保DOM已经更新
        this.$nextTick(() => {
          this.$router.push("/advertisementRecords");
          this.$store.commit("SET_ACTIVE", 0); // 设置广告策划审核为激活状态
          localStorage.setItem("activeName", "0"); // 保存状态
        });
      }
    }
  },
};
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.common {
  width: 100%;

  h2 {
    margin: 68px auto 44px;
    font-size: 47px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 77px;
  }
  &-top {
    .normal();
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    padding: 0 37px 0 100px;
    background: #ffffff;
    &-avatar {
      // font-size: 24px;
      // font-weight: 700;
      // color: #333;
      // font-family: PingFangSC, PingFang SC;
      // margin: 0
      width: 249px;
      height: 70px;
    }
    &-header {
      .normal();
      &-left {
        .normal();
        span {
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #242929;
          display: inline-block;
          margin-right: 37px;
          cursor: pointer;
        }
        :last-child {
          margin-right: 0;
          /deep/ .el-tabs__nav-wrap {
            padding: 0;
          }
        }
      }
      .adminStyle {
        margin-right: 20px;
      }
      &-right {
        .normal();
        &-bottom {
          width: 120px;
          height: 52px;
          border-radius: 8px;
          .normal();
          justify-content: center;
          cursor: pointer;
          margin: 20px 0;
        }
        .bottom1 {
          background: #f2f2f2;
          .fontdemo(18px, "PingFangSC,PingFang SC", 500, #000000);
        }
        .bottom2 {
          background: #4787f0;
          .fontdemo(18px, "PingFangSC,PingFang SC", 500, #FFFFFF);
          margin-right: 20px;
          margin-left: 102px;
        }
        &-user {
          padding: 20px 0;
          height: 52px;
          .normal();
          margin-left: 0px;
          position: relative;
          cursor: pointer;
          .avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
          }
          .count {
            margin: 0 20px 0 20px;
            .fontdemo(16px, "PingFangSC,PingFang SC", 600, rgba(0,0,0,0.85));
            text-align: left;
          }
          p {
            margin: 0;
          }
          &-toptip {
            width: 131px;
            padding: 13px 10px;
            background: #ffffff;
            box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.3);
            border-radius: 12px;
            box-sizing: border-box;
            position: absolute;
            top: 80px;
            right: 0;
            z-index: 99;
            p {
              .fontdemo(14px, "PingFangSC,PingFang SC", 600, rgba(0,0,0,0.85));
              border-bottom: 1px solid #c7c7cc;
              padding-bottom: 13px;
            }
            span {
              .fontdemo(14px, "PingFangSC,PingFang SC", 500, #808080);
              padding-top: 13px;
              display: block;
            }
          }
        }
      }
    }
  }
  &-footer {
    width: 100%;
    height: 284px;
    background: #4787f0;
    box-sizing: border-box;
    padding: 51px 90px 51px 157px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      text-align: left;
      h1 {
        .fontdemo(50px, "PingFangSC,PingFang SC", 600, #FFFFFF);
        margin-bottom: 20px;
      }
      h3 {
        .fontdemo(25px, "PingFangSC,PingFang SC", 400, rgba(255,255,255,0.5));
      }
    }
    &-right {
      text-align: left;
      h2 {
        .fontdemo(28px, "PingFangSC,PingFang SC", 500, #FFFFFF);
        margin: 0;
      }
      h4 {
        .fontdemo(20px, "PingFangSC,PingFang SC", 400, #FFFFFF);
        margin: 10px 0;
      }
      p {
        .fontdemo(20px, "PingFangSC,PingFang SC", 400, #FFFFFF);
        margin: 0;
      }
    }
  }
}

/deep/ .el-tabs__nav-wrap {
  padding: 0 10px;
}
/deep/ .el-tabs__item {
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #242929;
  line-height: 25px;
  display: flex;
  align-items: center;
}
/deep/ .el-tabs__nav-wrap {
  padding: 0;
  padding-right: 37px;
}
/deep/ .is-active {
  color: #000000 !important;
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-tabs__header {
  margin: 0;
}
.xy a {
  color: #fff;
  margin: 20px 0 20px;
}
.xy a:hover {
  color: red;
}
</style>
